import { api } from './axios'

/**
 * Visit endpoints (Phases 2-5 — vitals/medical/treatment/prescription).
 * Each new visit preserves the full history. Old visits are never overwritten.
 */
export const visitApi = {
  /** POST /patients/:id/visits — create new visit with any subset of 14 sections */
  create: (patientId, payload) =>
    api.post(`/patients/${patientId}/visits`, payload).then((r) => r.data),

  /** GET /patients/:id/visits — list all visits */
  listForPatient: (patientId, opts = {}) =>
    api.get(`/patients/${patientId}/visits`, opts).then((r) => r.data),

  /** GET /patients/:id/history — full history (personal + every visit) */
  getFullHistory: (patientId) =>
    api.get(`/patients/${patientId}/history`).then((r) => r.data),

  /** GET /visits/:visit_id — one visit, all sections */
  get: (visitId) => api.get(`/visits/${visitId}`).then((r) => r.data),

  /** PUT /visits/:visit_id/:section — correct a single section of an existing visit
   *  section is kebab-case in URL, e.g. 'vitals' / 'history-present-illness' / 'medical-history'
   */
  editSection: (visitId, section, payload) =>
    api.put(`/visits/${visitId}/${section}`, payload).then((r) => r.data),
}
